import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import ScoreByColor from "../../components/ExcerciseTypes/Design/ScoreByColor";

const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "Audios/bt_fpt_ai/p27_intro.mp3",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page27/Key/E1answerKey.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter:true,
    maxLength: 5,
    stylesTextInput: {
      borderBottom: "3px dotted black",
      // maxLength: 4,
      textAlign: "center",
      background: "none",
      fontSize: 24,
    },
    inputSize: 150,
    titleQuestion: [
      {
        num: "1",
        title: `
			  Viết tiếp vào chỗ chấm cho thích hợp (theo mẫu).
		    `,
        color: "rgb(99,197,244)",
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Nháy chuột vào chỗ chấm để điền tên gọi của các góc.</span>
        <video src="Audios/bt_fpt_ai/guide/p27_e1.mp3" controls style="width: 100%; height: 2cm"></video>
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position: relative'>
        <img src='/img/FriendsPlus/Page27/E1/1.jpg' style='height:19cm; width: 20cm; margin-bottom: 30px'/>
        <div style='position: absolute; top: 195px; left: 39px; display: flex'>

        <span style='padding-right: 373px'><span style='color: rgb(99,197,244)'>Mẫu: </span>Góc tù</span>
        <span style=''>Góc <input id= "0"></span>
        </div>
        <div style='position: absolute; top: 453px; left: 39px; display: flex'>
        <span style='padding-right: 298px'>Góc <input id= "1"></span>
        <span style=''>Góc <input id= "2"></span>
        </div>
        <div style='position: absolute; top: 690px; left: 39px; display: flex'>
        <span style='padding-right: 298px'>Góc <input id= "3"></span>
        <span style=''>Góc <input id= "4"></span>
        </div>
        </div>
        `,
        answer: ["nhọn", "bẹt", "vuông", "tù", "nhọn"],
      },
    ],
  },
  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    // audio: "Audios/bt_fpt_ai/p27_intro.mp3",
    // autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page27/Key/E2answerKey.png",
    component: T6,
    isHiddenCheck: true,
    // hideBtnFooter:true,
    maxLength: 1,
    stylesTextInput: {
      border: "2px solid black",
      borderRadius: 10,
      padding: 10,
      textAlign: "center",
      // background: "none",
      fontSize: 24,
      height: 50,
      textTransform: "uppercase",
    },
    inputSize: 50,
    titleQuestion: [
      {
        num: "2",
        title: `
			  Bạn Nam vẽ hai mũi tàu như hình sau. Em hãy ghi chữ A vào con tàu có mũi là một góc tù và chữ B vào con tàu có mũi là một góc nhọn.
		    `,
        color: "rgb(99,197,244)",
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    guideModal: [
      {
        title: "hướng dẫn",
        description: `
        <span>Nháy chuột vào chỗ chấm để điền chữ cái A hoặc B vào ô trống dưới hình mỗi con tàu cho phù hợp.
        </span>
        <video src="Audios/bt_fpt_ai/guide/p27_e2.mp3" controls style="width: 100%; height: 2cm"></video>
        
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <div style='position: relative'>
        <img src='/img/FriendsPlus/Page27/E2/1.jpg' style='height:8cm; width: 26cm; margin-bottom: 30px'/>
        <div style='position: absolute; top: 221px; left: 24px; display: flex'>

        <span style='padding-right: 502px'><input id= "0"></span>
        <span style=''><input id= "1"></span>
        </div>
        </div>
        `,
        answer: ["A", "B"],
      },
    ],
  },
};

export default json;
